export enum TravelClass {
    first = 'F',
    business = 'B',
    economy = 'Y',
    premiumEconomy = 'W'
}

export interface TravelClassForDropdown {
    name: string,
    id: number,
    value: TravelClass
}

export const firstClass: TravelClassForDropdown = {
    id: 1,
    name: 'ACTIVITIES.FLIGHT.FLIGHT_CLASS_FIRST',
    value: TravelClass.first
};
export const businessClass: TravelClassForDropdown = {
    id: 2,
    name: 'ACTIVITIES.FLIGHT.FLIGHT_CLASS_BUSINESS',
    value: TravelClass.business
};
export const economyClass: TravelClassForDropdown = {
    id: 3,
    name: 'ACTIVITIES.FLIGHT.FLIGHT_CLASS_ECONOMY',
    value: TravelClass.economy
};
export const premiumEconomyClass: TravelClassForDropdown = {
    id: 4,
    name: 'ACTIVITIES.FLIGHT.FLIGHT_CLASS_ECONOMY_PREMIUM',
    value: TravelClass.premiumEconomy
};
export const TRAVEL_CLASSES: TravelClassForDropdown[] = [
    firstClass, businessClass, premiumEconomyClass, economyClass
];